import type { CourseModule } from "@/core/types";
import { lektionPivotBauen } from "./lektion-01-pivot-bauen";
import { lektionDatenschnitte } from "./lektion-02-datenschnitte";
import { lektionPivotChart } from "./lektion-03-pivotchart";

export const modulPivot: CourseModule = {
  id: "pivot",
  title: "PivotTables und Datenschnitte",
  summary:
    "Zusammenfassen ohne eine einzige Formel – und Filter, die man sieht, statt " +
    "eines Trichtersymbols, das niemand bemerkt.",
  level: "Aufbau",
  lessons: [lektionPivotBauen, lektionDatenschnitte, lektionPivotChart],
};
